import { getAvatarMaterials } from './avatarMaterial'

// Apply / clear / re-intensity the specular envMap on the avatar's materials.
// PBR / Physical / graph-standard materials use the native `envMap` property.
// Toon-graph materials (MeshToon has no native envMap) are handled by their own
// branch — see setToonEnvOnAll in avatarMaterial.js, called from EnvProbe.

export function applyEnvToAll(envTexture, envMapIntensity) {
  const mats = getAvatarMaterials()?._all ?? []
  for (const mat of mats) {
    if (!mat || mat.userData?.isToonGraph) continue
    mat.envMap = envTexture
    mat.envMapIntensity = envMapIntensity
    mat.needsUpdate = true
  }
}

export function clearEnvFromAll(target) {
  const mats = getAvatarMaterials()?._all ?? []
  for (const mat of mats) {
    if (mat && !mat.userData?.isToonGraph && mat.envMap === target) {
      mat.envMap = null
      mat.needsUpdate = true
    }
  }
}

export function setEnvIntensityOnAll(envMapIntensity) {
  const mats = getAvatarMaterials()?._all ?? []
  for (const mat of mats) {
    if (mat && !mat.userData?.isToonGraph && mat.envMap) {
      mat.envMapIntensity = envMapIntensity
      mat.needsUpdate = true
    }
  }
}
